import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "consent-group" }
const _hoisted_6 = { class: "checkbox-label" }
const _hoisted_7 = { class: "checkbox-label" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h2", null, "Welcome to the MyUser Demo!"),
              _createElementVNode("p", null, "Enter your contact info to see personalized demo messages")
            ], -1)),
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
              class: "demo-form"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { for: "email" }, "Email Address", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  type: "email",
                  placeholder: "you@example.com",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { for: "phone" }, "Phone Number", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "phone",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event)),
                  type: "tel",
                  placeholder: "+1 (555) 123-4567",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.consentEmail) = $event)),
                    type: "checkbox",
                    required: ""
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.consentEmail]
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("span", null, "I agree to receive emails", -1))
                ]),
                _createElementVNode("label", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.consentSms) = $event)),
                    type: "checkbox",
                    required: ""
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.consentSms]
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "I agree to receive SMS messages", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn-primary",
                  disabled: _ctx.loading,
                  onTouchend: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.loading ? 'Saving...' : 'Start Demo'), 41, _hoisted_9),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-secondary",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSkip && _ctx.handleSkip(...args))),
                  onTouchend: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSkip && _ctx.handleSkip(...args)), ["prevent"]))
                }, " Skip for now ", 32)
              ])
            ], 32),
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "disclaimer" }, " This is a demo environment. No real messages will be sent. ", -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}